"use client";

import type { Variants } from "@/components/ui/alert";
import { useToast } from "@/components/ui/use-toast";
import { useEffect } from "react";

export const AuthCodeErrorToast = ({
  message,
  variant = "error",
}: {
  message?: string;
  variant?: Variants;
}) => {
  const { toast } = useToast();

  useEffect(() => {
    if (message) {
      // initial load時にtoastが表示されないため、setTimeoutで表示する
      setTimeout(() => {
        toast({
          title: message,
          variant,
          duration: 30 * 1000,
        });
      });
    }
  }, [toast, message, variant]);

  return null;
};
